export default __webpack_public_path__ + "static/media/checkmark.c4029fa2.svg";